// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
let __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-assets_seshy_js-rewritten-packages_embroider_macros_1f84f2e6_node_modules_embroider_m-331356","_embroider_babel-loader-9_index_js_variant_name_dev_runtime_browser_optimizeForProduction_fal-1f0072"], () => (__webpack_require__("./assets/seshy.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
